export * from './login-country'

export const AUTHENTICATION_REQUIRED_HEADER = 'x-podo-authentication-required'
